// src/components/charts/ChartCard.jsx
import React from 'react';

const FONT = "'DM Sans', sans-serif";
const COLOR = { text: '#1d1d1f', muted: '#6c6c6d', border: 'rgba(0,0,0,0.08)' };

// Small pill indicating whether a chart is exact over the whole period
// (population-true /runs/stats) or a recent capped sample (/runs?limit=200).
// Kept here so every card renders the badge identically.
function ReliabilityBadge({ reliability }) {
  if (!reliability) return null;
  const isExact = reliability.kind === 'exact';
  const label = isExact ? 'Tutto il periodo' : `Campione: ultimi ${reliability.n}`;
  const bg = isExact ? 'rgba(16,185,129,0.10)' : 'rgba(245,158,11,0.12)';
  const fg = isExact ? '#0F8F6B' : '#B26B00';
  return (
    <span
      title={isExact
        ? 'Calcolato su tutte le run del periodo'
        : 'Calcolato sulle run più recenti (max 200) — non è il dato completo del periodo'}
      style={{
        fontSize: 10, fontWeight: 600, textTransform: 'none', letterSpacing: 0,
        padding: '2px 8px', borderRadius: 999, background: bg, color: fg,
        whiteSpace: 'nowrap', flexShrink: 0,
      }}
    >
      {label}
    </span>
  );
}

export default function ChartCard({ title, subtitle, loading, empty, reliability, children }) {
  return (
    <div style={{
      padding: '16px 18px', borderRadius: 8,
      border: `1px solid ${COLOR.border}`, background: '#fff',
      marginBottom: 16, fontFamily: FONT,
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 8, marginBottom: 4,
      }}>
        <div style={{ fontSize: 11, color: COLOR.muted, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          {title}
        </div>
        <ReliabilityBadge reliability={reliability} />
      </div>
      {subtitle && (
        <div style={{ fontSize: 12, color: COLOR.muted, marginBottom: 12 }}>{subtitle}</div>
      )}
      {loading && <div style={{ fontSize: 13, color: COLOR.muted, padding: '24px 0' }}>Caricamento…</div>}
      {!loading && empty && (
        <div style={{ fontSize: 13, color: COLOR.muted, padding: '24px 0' }}>Nessun dato nel periodo.</div>
      )}
      {!loading && !empty && children}
    </div>
  );
}
